import React from 'react'
import { Layout } from 'antd'

const { Footer } = Layout

const AppFooter = () => <Footer className='footer'>React Admin &copy;2025 Created By Joshua</Footer>
export default AppFooter;